import React, { useCallback, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import MMDrawer from 'components/MMDrawer';
import {
  actionCloseSelectWorkOrderOp,
  actionOpenSelectWorkOrderOp,
} from 'lib/actions';
import SelectWorkOrderOpModal from 'pages/SelectJob/SelectWorkOrderOp/SelectWorkOrderOpModal';
import {
  selectJobPageInitialState,
  selectJobPageReducer,
} from 'pages/SelectJob/selectJobPageReducer';
import { SelectJobFlowProvider } from 'pages/SelectJob/SelectJobFlowContext';

/**
 * Full-height bottom drawer with the same single-select job UI as /selectJob,
 * without leaving the machine route (avoids redirect / remount issues).
 */
const SingleSelectJobDrawer = ({ isOpen, onClose, flowContextValue }) => {
  const storeDispatch = useDispatch();
  const [state, dispatch] = useReducer(
    selectJobPageReducer,
    selectJobPageInitialState
  );

  useEffect(() => {
    if (isOpen) {
      dispatch({ type: 'RESET' });
      storeDispatch(actionOpenSelectWorkOrderOp());
    } else {
      storeDispatch(actionCloseSelectWorkOrderOp());
    }
  }, [isOpen, storeDispatch]);

  const handleDrawerClose = useCallback(() => {
    storeDispatch(actionCloseSelectWorkOrderOp());
    onClose();
  }, [onClose, storeDispatch]);

  const noopNextStep = useCallback(() => {}, []);

  if (!isOpen) {
    return null;
  }

  return (
    <MMDrawer hideHeader isOpen={isOpen} onClose={handleDrawerClose}>
      <SelectJobFlowProvider value={flowContextValue}>
        <SelectWorkOrderOpModal
          embeddedInDrawer
          dispatch={dispatch}
          handleOnClose={handleDrawerClose}
          nextStep={noopNextStep}
          {...state}
        />
      </SelectJobFlowProvider>
    </MMDrawer>
  );
};

SingleSelectJobDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  flowContextValue: PropTypes.shape({
    apmFlowState: PropTypes.object,
    splitJobContext: PropTypes.object,
    onApmFlowComplete: PropTypes.func,
  }),
};

SingleSelectJobDrawer.defaultProps = {
  flowContextValue: null,
};

export { SingleSelectJobDrawer };
